export default __webpack_public_path__ + "fonts/5f79700b5d9a0096ff189e1268e730cd.woff";